import React from "react"
import { Route } from "react-router-dom"
import { AnimatedSwitch } from "react-router-transition"
import Index from "../pages/Index"
import Event from "../pages/Event"
import NotFound from "../pages/NotFound"

export default ({ childProps }) => (
  <AnimatedSwitch
    atEnter={{ opacity: 0 }}
    atLeave={{ opacity: 0 }}
    atActive={{ opacity: 1 }}
  >
    <Route path="/" exact component={Index} />
    <Route path="/:event_url/display" component={Event} />
    <Route path="/:event_url/display2" component={Event} />
    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </AnimatedSwitch>
)



// WEBPACK FOOTER //
// ./src/routes/index.jsx